import {InboundWebhookDeliveryStatus, InboundWebhookRequest} from '@supermove/models';
import {colors} from '@supermove/styles';

interface StatusPretty {
  name: string;
  color: string;
}

export const LeadProviderRequestStatus = {
  pretty: {
    [InboundWebhookDeliveryStatus.Queued]: {name: 'Queued', color: colors.gray.primary},
    [InboundWebhookDeliveryStatus.InProgress]: {name: 'In Progress', color: colors.blue.hover},
    [InboundWebhookDeliveryStatus.Success]: {name: 'Success', color: colors.green.status},
    [InboundWebhookDeliveryStatus.Error]: {name: 'Error', color: colors.orange.status},
  } as const,

  fromRequest: (request?: InboundWebhookRequest): StatusPretty | undefined => {
    if (!request) {
      return undefined;
    }
    if (!request.mostRecentDelivery) {
      return LeadProviderRequestStatus.pretty[InboundWebhookDeliveryStatus.Queued];
    }
    if (request.mostRecentDelivery.isExpired) {
      return LeadProviderRequestStatus.pretty[InboundWebhookDeliveryStatus.Error];
    }
    return LeadProviderRequestStatus.pretty[request.mostRecentDelivery.status];
  },
} as const;
